import { render, staticRenderFns } from "./SendEmailForNewFeature.vue?vue&type=template&id=17e68aae&scoped=true&"
import script from "./SendEmailForNewFeature.vue?vue&type=script&lang=ts&"
export * from "./SendEmailForNewFeature.vue?vue&type=script&lang=ts&"
import style0 from "./SendEmailForNewFeature.vue?vue&type=style&index=0&id=17e68aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e68aae",
  null
  
)

export default component.exports